<template>
  <div class="about-yourself-layout__container">
    <div class="about-yourself-layout">
      <slot />
    </div>
    <div class="col-right">
      <img
        src="../assets/img/egresa_logo.png"
        class="logo mb-5"
        alt
      >
      <img
        src="../assets/group-2990.jpg"
        srcset="../assets/group-2990@2x.jpg 2x, ../assets/group-2990@3x.jpg 3x"
        class="img"
      >
    </div>
  </div>
</template>

<script>
export default {
    name: 'AboutYourselfLayout',
};
</script>

<style lang="scss" scoped>
.about-yourself-layout__container{
    display: flex;
}
.about-yourself-layout {
  background-color: #2e89df;
  padding: 20px;
  min-height: 100vh;
  position: relative;

  @media screen and (min-width: 600px) {
    max-width: 680px;
    padding: 40px !important;
  }
}
.col-right {
  position: relative;
  flex: 1;
//   min-height: 700px;
  display: none;
  @media screen and (min-width: 600px) {
      display: block;
  }
  .img {
    width: 100%;
    max-width: 500px;
    position: absolute;
    right: 0;
    bottom: 0;
  }
  .logo {
    position: absolute;
    max-width: 180px;
    right: 50px;
    top: 20px;
    z-index: 99;
  }
}
</style>
